import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/resources/images/icons/map.svg")